import { useEffect, useMemo, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ValidFieldTypes } from '../../../types';
import { ECardType } from '../../../utils/config';
import { cvv3Digits, cvv4Digits } from '../../../utils/regexp';
import { Text } from '../../FormContainer/FormTypes/Text';
import type { FieldComponentProps, TSecurityCodeProps } from '../../../types';

const SecurityCode = (props: TSecurityCodeProps) => {
  const { show, handleShow, ...rest } = props;

  return (
    <div {...rest} className='security-code-toggle'>
      <input
        type='checkbox'
        id='cvv-visibility-toggle'
        checked={show}
        onChange={() => {
          handleShow();
        }}
      />
      <label htmlFor='cvv-visibility-toggle' aria-label='Show security code' />
    </div>
  );
};

export const Cvv = ({ isFetching, potentialCardType }: FieldComponentProps) => {
  const [showCode, setShowCode] = useState<boolean>(false);

  const handleShow = (isShow?: boolean) => {
    setShowCode((prev) => isShow ?? !prev);
  };

  const isFirstRender = useRef(true);
  const {
    trigger,
    setValue,
    formState: { isDirty },
  } = useFormContext();

  const fieldName = ValidFieldTypes.CVV;
  const cvvLength = useMemo(() => (potentialCardType === ECardType.AMEX ? 4 : 3), [potentialCardType]);
  const cvvPattern = useMemo(() =>
    potentialCardType === ECardType.AMEX ? cvv4Digits : cvv3Digits, [potentialCardType]);

  const handleChange = (value) => {
    const inputVal = value.replace(/\D/g, '');
    setValue(fieldName, inputVal);
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    isDirty && trigger(fieldName);
  }, [potentialCardType]);

  return (
    <Text
      {...{
        type: showCode ? 'text' : 'password',
        onChange: handleChange,
        params: {
          name: fieldName,
          required: true,
          maxLength: cvvLength,
          pattern: cvvPattern,
          disabled: isFetching,
        },
        icon: <SecurityCode show={showCode} handleShow={handleShow} />,
      }}
    />
  );
};
